import * as React from 'react';
import { DayPickerProps } from 'react-day-picker';
// tslint:disable-next-line:no-submodule-imports
import DayPicker from 'react-day-picker/DayPicker';
import Styled from 'styled-components';

import DatePickerStyles from './DatePickerStyles';
import { usePrepDayPickerProps } from './DatePickerInput';

const DatePickerContainer = Styled.div`
  ${DatePickerStyles}

  .DayPicker-Day--selected {
    border-radius: 0;
  }

  .DayPicker-Day--selected.DayPicker-Day--start {
    border-top-left-radius: ${({ theme: { datepicker: { selection: { borderRadius } } } }) => borderRadius};
    border-bottom-left-radius: ${({ theme: { datepicker: { selection: { borderRadius } } } }) => borderRadius};
    font-weight: 700;
  }

  .DayPicker-Day--selected.DayPicker-Day--end {
    border-top-right-radius: ${({ theme: { datepicker: { selection: { borderRadius } } } }) => borderRadius};
    border-bottom-right-radius: ${({ theme: { datepicker: { selection: { borderRadius } } } }) => borderRadius};
    font-weight: 700;
  }
`;

export interface IRangeDatePickerProps {
  // tslint:disable-next-line:no-reserved-keywords
  range: { from?: Date; to?: Date };
}

const RangeDatePicker: React.FC<IRangeDatePickerProps & DayPickerProps> = ({ range, ...props }) => {
  const modifiers = {
    start: range.from,
    end: range.to,
  };

  const dayPickerProps = usePrepDayPickerProps(props || {});

  return (
    <DatePickerContainer>
      <DayPicker
        {...dayPickerProps}
        // @ts-ignore
        selectedDays={[range.from, range]}
        modifiers={{ ...(props.modifiers || {}), ...modifiers }}
      />
    </DatePickerContainer>

  );
};

RangeDatePicker.displayName = 'RangeDatePicker';

export default RangeDatePicker;
